import { render, staticRenderFns } from "./website-cultural.vue?vue&type=template&id=115200cb&scoped=true"
import script from "./website-cultural.vue?vue&type=script&lang=js"
export * from "./website-cultural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115200cb",
  null
  
)

export default component.exports